import { render } from "./TreuhandEditAccountDialog.vue?vue&type=template&id=6c434752&ts=true"
import script from "./TreuhandEditAccountDialog.vue?vue&type=script&lang=ts"
export * from "./TreuhandEditAccountDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__